<div class="container-fluid">
    <input type="text" class="form-control w-100" [name]="question.code" [id]="question.code" placeholder="{{placeholder}}"
        minLength="{{min}}" maxLength="{{max}}" required [disabled]="summaryMode" (blur)="onClick()"
        [(ngModel)]="textValue" #answerValidation="ngModel">

    <mat-error *ngIf="question.invalid">required</mat-error>
    <mat-error *ngIf="answerValidation.errors?.minlength">Answer must be at least {{min}} characters long.</mat-error>
</div>